(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offhoo-taxonomy-menu"] && !Shopify.designMode) return;
  try {
    function closeOffhooDesktopMenus(exceptItem) {
    document.querySelectorAll('[data-offhoo-menu-item].is-open').forEach((item) => {
      if (item === exceptItem) return;

      item.classList.remove('is-open');
      item.querySelector('[data-offhoo-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  function syncOffhooMobileDrawer(details) {
    if (!(details instanceof HTMLDetailsElement)) return;

    const isOpen = details.open;
    details.classList.toggle('menu-open', isOpen);
    details.querySelector('summary')?.setAttribute('aria-expanded', String(isOpen));
  }

  function closeOffhooMobileDrawer(details) {
    if (!(details instanceof HTMLDetailsElement)) return;

    details.open = false;
    syncOffhooMobileDrawer(details);
  }

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-offhoo-mobile-drawer')) return;

    syncOffhooMobileDrawer(details);
  });

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-offhoo-drawer-close]');

    if (closeTrigger) {
      const details = closeTrigger.closest('[data-offhoo-mobile-drawer]');
      closeOffhooMobileDrawer(details);
      return;
    }

    const desktopToggle = event.target.closest('[data-offhoo-menu-toggle]');

    if (desktopToggle) {
      const menuItem = desktopToggle.closest('[data-offhoo-menu-item]');
      const isOpen = menuItem?.classList.contains('is-open');

      closeOffhooDesktopMenus(menuItem);
      menuItem?.classList.toggle('is-open', !isOpen);
      desktopToggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    const mobileToggle = event.target.closest('[data-offhoo-mobile-toggle]');

    if (mobileToggle) {
      const panel = document.getElementById(mobileToggle.getAttribute('aria-controls'));
      const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';

      mobileToggle.setAttribute('aria-expanded', String(!isOpen));

      if (panel) {
        panel.hidden = isOpen;
      }

      return;
    }

    if (!event.target.closest('[data-offhoo-menu-item]')) {
      closeOffhooDesktopMenus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openItem = document.querySelector('[data-offhoo-menu-item].is-open');
    closeOffhooDesktopMenus();
    openItem?.querySelector('[data-offhoo-menu-toggle]')?.focus();

    document.querySelectorAll('[data-offhoo-mobile-toggle][aria-expanded="true"]').forEach((toggle) => {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');

      if (panel) {
        panel.hidden = true;
      }
    });

    document.querySelectorAll('[data-offhoo-mobile-drawer][open]').forEach((details) => {
      closeOffhooMobileDrawer(details);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
